module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on one jaw 14.0b5d8e07.png";